import { render, staticRenderFns } from "./courses.vue?vue&type=template&id=822f3da8&scoped=true&"
import script from "./courses.vue?vue&type=script&lang=js&"
export * from "./courses.vue?vue&type=script&lang=js&"
import style0 from "./courses.vue?vue&type=style&index=0&id=822f3da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822f3da8",
  null
  
)

component.options.__file = "courses.vue"
export default component.exports